import { VersionRead } from '@/api/dashboard'
import {
  Button,
  Input,
  Modal,
  ModalContent,
  ModalFooter,
  ModalProps,
  ModalTitle,
  formatHookFormErrors,
} from '@dashboard/ui'
import { dashboardClient, getErrorText } from '@/api'
import { FieldGroup, ToastSeverity, useToast } from '@/ui'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

interface RefundModalProps extends ModalProps {
  version: VersionRead
}

interface RefundModalForm {
  version_description: string
}

export const RenameVersionModal = ({ version, ...rest }: RefundModalProps) => {
  const { companyId, gameId, eventId } = useParams() as {
    companyId: string
    gameId: string
    eventId: string
  }
  const { t } = useTranslation()
  const showToast = useToast()

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<RefundModalForm>({
    values: {
      version_description: version.version_description,
    },
  })

  const onRefundConfirm = async (data: RefundModalForm) => {
    try {
      await dashboardClient.v1.updateCampaignVersion(version.id, companyId, gameId, eventId, {
        version_description: data.version_description,
      })
      rest.onClose()
      showToast({ message: t('saved'), severity: ToastSeverity.success })
    } catch (e) {
      showToast({ severity: ToastSeverity.error, message: getErrorText(e) })
    }
  }

  return (
    <Modal {...rest}>
      <form onSubmit={handleSubmit(onRefundConfirm)}>
        <ModalContent>
          <ModalTitle>{t('campaign.versions.edit-description')}</ModalTitle>
          <FieldGroup label={t('campaign.version_description')}>
            <Input
              autoFocus
              {...register('version_description', { required: t('validation.required') })}
              {...formatHookFormErrors(errors, 'version_description')}
            />
          </FieldGroup>
        </ModalContent>
        <ModalFooter>
          <Button variant="outline" color={'secondary'} size="sm" onClick={rest.onClose} type="button">
            {t('Cancel')}
          </Button>
          <Button size="sm" type="submit" loading={isSubmitting}>
            {t('Save')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
